import React from 'react';
import classnames from 'classnames';

import { Maybe } from '../../../graphql.schema';

import * as styles from './RichTextField.module.scss';

type Props = {
  className?: string;
  content?: Maybe<string>;
};

export const RichTextField = ({ className, content }: Props) => (
  <div
    className={classnames('content rich-text', styles.root, className)}
    dangerouslySetInnerHTML={{ __html: content ?? '' }}
  />
);
